export const version = 'v1.50.E.20210406.01';
export const appClient = 'eicon';
export const appProduct = 'dte';
export const appOperation = '';
export const gerenciarSistemasRouterPath = '/configuracao/configurar-aplicacoes';
export const graphicCollors = {"axisColor":"#DADADA","baseColor":"#005baa","lineColor":"#04874b","fillColors":"#04874b","bulletColor":"#04874b"};
export const swallCollors = {"confirmButtonColor":"#005baa","cancelButtonColor":"#dc3545"};  
